// sectorProfesor.js — «Profesor de autoescuela» en el selector de Sector de la ficha del lead (26/10/2026).
//
// No es un sector nuevo: en c_contactos se guarda sector "autoescuela" + autoescuela_plan "profesor", el MISMO
// campo que c_empresas.autoescuela_plan. Así todo lo que trata el sector (Flows, plantillas, emails, embudo,
// reglas de demo, captación, vertical oculta…) lo sigue viendo como autoescuela sin tocar nada, y Supervisión
// ya lo pinta como «Profesor» (planProfesorOf). Solo el selector, el chip, el simulador y «Crear accesos» miran
// la marca. Ficha: docs/features/autoescuela-plan-profesor.md
//
// SECTOR_PROFESOR es el valor del <option> (y el id de la tarjeta del simulador), nunca se guarda en el lead.

export const SECTOR_PROFESOR = "autoescuela_profesor";
export const ETIQUETA_PROFESOR = "Profesor de autoescuela";

/** ¿El lead es un profesor de autoescuela (Plan Profesor)? */
export function esLeadProfesor(lead) {
  return !!lead && lead.sector === "autoescuela" && lead.autoescuela_plan === "profesor";
}

/** Valor del selector de Sector para un lead (o formData). */
export function valorSelectorSector(lead) {
  if (esLeadProfesor(lead)) return SECTOR_PROFESOR;
  return (lead && lead.sector) || "";
}

/** Campos del lead al elegir una opción del selector. autoescuela_plan "" = se quita. */
export function camposLeadDeSelector(valor) {
  if (valor === SECTOR_PROFESOR) return { sector: "autoescuela", autoescuela_plan: "profesor" };
  return { sector: valor || "", autoescuela_plan: "" };
}
